import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';

const DEFAULT_THRESHOLD: number = 50;

interface IDirectiveScope {
    loadMore: Function;
    threshold: number;
}

directive.$inject = ['$window'];
function directive($window: ng.IWindowService): ng.IDirective {
    return {
        restrict: 'A',
        link: linkFn,
        scope: {
            loadMore: '&loadMore',
            threshold: '<'
        }
    };

    function linkFn(scope: ng.IScope & IDirectiveScope) {
        const body = $window.document.body;
        const threshold = scope.threshold || DEFAULT_THRESHOLD;

        scope.$on('$destroy', function() {
            $window.removeEventListener('scroll', scrollEventListener);
        });

        $window.addEventListener('scroll', scrollEventListener);

        function scrollEventListener() {
            const scrollPos = $window.innerHeight + window.pageYOffset + threshold;
            if (scrollPos >= body.scrollHeight) {
                scope.loadMore();
            }
        }

    }
}

angular
    .module('app.common')
    .directive('ngInfiniteScroll', directive);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/directives/ng-infinite-scroll.ts